import { EventsManager } from '@game-libs/events-manager';
import { AudioManager } from '@game-libs/audio-manager';
import { Engine } from 'excalibur';
import { DungeonEvents } from '../types/game-events';
import { getRandomThing } from '@game-libs/exc-libs';
import { SFXList } from '.';
import { RewardId } from '../components/DungeonCrawler/DungeonChest';


export const initDungeonEventsListeners = (game: Engine) => {
  const { playSFXNow, playMusicTrack, stop } = AudioManager();
  const { on } = EventsManager();

  const doorsSFXList: SFXList = [
    { value: 'door_open_1', probability: 50 },
    { value: 'door_open_2', probability: 50 },
  ];

  const footstepsSFXList: SFXList = [
    { value: 'footsteps_1', probability: 15 },
    { value: 'footsteps_2', probability: 15 },
    { value: 'footsteps_3', probability: 14 },
    { value: 'footsteps_4', probability: 14 },
    { value: 'footsteps_5', probability: 14 },
    { value: 'footsteps_6', probability: 14 },
    { value: 'footsteps_7', probability: 14 },
  ];

  on(DungeonEvents.OPEN_CHEST, () => {
    playSFXNow('chest_open');
  });

  on(DungeonEvents.OPEN_DOOR, () => {
    playSFXNow(getRandomThing<string>(doorsSFXList));
  });

  on(DungeonEvents.OPEN_EXIT_DOOR, () => {
    playSFXNow(getRandomThing<string>(doorsSFXList));
  });

  on(DungeonEvents.DOOR_LOCKED, () => {
    playSFXNow('door_locked');
  });

  on(DungeonEvents.START_BATTLE, () => {
    playSFXNow('start_battle');
  });

  on(DungeonEvents.FOOTSTEP, () => {
    playSFXNow(getRandomThing<string>(footstepsSFXList), 0.5);
  });

  on(DungeonEvents.PICK_ITEM, ({ itemId }: { itemId: string }) => {
    setTimeout(() => {
      switch (itemId) {
        case RewardId.NOTHING:
          playSFXNow('nothing');
          break;
        default:
          playSFXNow('pickup');
          break;
      }
    }, 500);
  });

  on(DungeonEvents.ENTER_DUNGEON, () => {
    stop('game_music');
    setTimeout(() => {
      playMusicTrack('dungeon_music');
    }, 100);

  });

  on(DungeonEvents.EXIT_DUNGEON, () => {
    stop('dungeon_music');

    setTimeout(() => {
      stop('game_music');
      playMusicTrack('game_music');
    }, 1000);
  });

};
